<template>
    <div id="m-inbox" style="height: 100%">
        <v-card elevation="0">
            <v-card-actions style="height: 70px!important;">
                <v-tabs v-model="tab" class="no-transition">
                    <v-tab key="tab-test-u">Game Save Actions
                        <v-icon size="20" style="margin-left: 8px">mdi-content-save</v-icon>
                    </v-tab>
                </v-tabs>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 mx-2" style="border-bottom: green solid 0px;">
                <v-card width="100%" class="ma-0 pa-0 scroll" elevation="0" :height="winsize.height - 145">
                    <v-tabs-items class="mt-0" v-model="tab">
                        <v-tab-item
                                transition="fade-transition"
                                reverse-transition="fade-transition"
                                key="tab-test-u">
                            <utils-map-save-actions-page></utils-map-save-actions-page>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import UtilsMapSaveActionsPage from "./views/utils-map-save-actions-page.vue";



export default {
    components: {UtilsMapSaveActionsPage},
    data: () => ({
        tab: null,
        // header: [
        //     {text: 'Email', sortable: true, value: 'email', class: "white blue--text", color: "red"},
        //     {text: 'Uid', sortable: true, value: 'uid', class: "white blue--text", color: "red"},
        //     {text: 'Actions', sortable: false, value: 'actions', class: "white blue--text", width:'20%', align:'end'}
        // ],
        // loading: true,
        // message: "",
    }),
    computed:{
        winsize() {
            return window.app.winsize;
        }
        // frontendUsers(){
        //     return PermissionsStoreUtils.getUsers()
        // }
    },
    methods: {
        // ifCanEdit(){
        //     let userUid = PermissionsStoreUtils.getMyUserUid()
        //     return PermissionsStoreUtils.getPermission(userUid, PermissionsStoreUtils.PERMISSION_TAB.subpermissions.PERMISSION_TAB_EDIT.id)
        // },
        // onPressEdit(user){
        //     this.$refs['p-edit-permissions-popup'].show(user)
        // }
    },
    beforeMount() {
        //this.loading = false
    },
    destroyed() {
        console.log("destroy root view permissions");
    }
}
</script>

<style scoped>
</style>